import React, { Component } from 'react';
import { DropdownV2, TextInput, Button } from 'carbon-components-react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { Card } from '../../../../../components';
import {
  getByDmService,
  getDmService,
  insertDmService,
  updateDmService,
} from '../../../../../services/Api';
import Breadcrumb from '../../../../../shared/breadcrumb/Breadcrumb';

class Edit extends Component {
  static propTypes = {
    hiddenModal: PropTypes.func,
  };

  static defaultProps = {
    hiddenModal: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedItemType: { id: 0, label: 'Selecione' },
      nameCategory: '',
      descriptionTextarea: '',
      categoryMessage: [],
      categorySac: [],
      disabledButton: true,
      // openMessageEdit: false,
    };
  }

  componentWillMount() {
    const { match } = this.props;
    const idEdit = match !== undefined ? match.params.id : false;
    if (idEdit) {
      this.getData(idEdit);
    }
    this.getCategory();
    this.enableButton();
  }

  getData = idEdit => {
    getByDmService('/ModeloCategoria/Get', idEdit)
      .then(res => {
        this.setState({
          descriptionTextarea: res.descricao,
          selectedItemType: res.tipo === 1 ? { id: 1, label: 'Mensagem' } : { id: 2, label: 'SAC' },
          nameCategory: res.nome,
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getCategory() {
    const { match } = this.props;
    const idEdit = match !== undefined ? match.params.id : false;
    if (idEdit) {
      getDmService('ModeloCategoria/Get')
        .then(res => {
          this.insertArrTypes(res);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  edit = () => {
    const { disabledButton, selectedItemType, descriptionTextarea, nameCategory } = this.state;
    const { match } = this.props;
    if (!disabledButton) {
      const idEdit = match !== undefined ? match.params.id : false;
      const typeMessage = selectedItemType.id;
      const descricao = descriptionTextarea;
      const formData = {
        Id: idEdit,
        tipo: typeMessage,
        Descricao: descricao,
        Nome: nameCategory,
      };

      updateDmService('/ModeloCategoria', idEdit, formData);
      toast.success('Alterações realizadas com sucesso.');
      setTimeout(() => {
        window.location.href = '/admin/modelos-categorias';
      }, 2000);
    } else {
      toast.error('Verifique se todos os campos necessários estão preenchidos.');
    }
  };

  save = () => {
    const { disabledButton, selectedItemType, descriptionTextarea, nameCategory } = this.state;
    const { hiddenModal } = this.props;
    if (!disabledButton) {
      const tipoMessage = selectedItemType.id;
      const descricao = descriptionTextarea;

      const formData = {
        tipo: tipoMessage,
        Descricao: descricao,
        Nome: nameCategory,
      };

      insertDmService('/ModeloCategoria', formData);
      setTimeout(() => {
        toast.success('Categoria salva com sucesso.');
        if (hiddenModal) {
          this.setState({
            selectedItemType: { id: 0, label: 'Selecione' },
            nameCategory: '',
          });
          hiddenModal();
        } else {
          window.location.href = '/admin/modelos-categorias';
        }
      }, 2000);
    } else {
      toast.error('Verifique se todos os campos necessários estão preenchidos.');
    }
  };

  onChange = (item, change) => {
    if (change === 'tipo') {
      this.setState({ selectedItemType: item.selectedItem }, () => {
        this.enableButton();
      });
    } else {
      this.setState({ nameCategory: item.target.value }, () => {
        this.enableButton();
      });
    }
  };

  onChangeText = value => {
    this.setState({ descriptionTextarea: value }, () => {
      this.enableButton();
    });
  };

  enableButton = () => {
    const { match } = this.props;
    const idEdit = match !== undefined ? match.params.id : false;
    const { nameCategory, selectedItemType } = this.state;
    if ((nameCategory && selectedItemType.id !== 0) || idEdit) {
      this.setState({
        disabledButton: false,
      });
    } else {
      this.setState({
        disabledButton: true,
      });
    }
  };

  addTag = tag => {
    this.setState(prevState => ({
      descriptionTextarea: `${prevState.descriptionTextarea}${tag}`,
    }));
  };

  cancel = () => {
    const { inheritModal, hiddenModal } = this.props;
    if (inheritModal) {
      hiddenModal();
    } else {
      window.location.href = '/admin/modelos-categorias';
    }
  };

  insertArrTypes(data) {
    data.forEach(item => {
      if (item.tipo === 1) {
        this.setState(prevState => ({
          categoryMessage: [...prevState.categoryMessage, { id: item.id, label: item.descricao }],
        }));
      } else if (item.tipo === 2) {
        this.setState(prevState => ({
          categorySac: [...prevState.categorySac, { id: item.id, label: item.descricao }],
        }));
      }
    });
  }

  openMessage(/* open */) {
    this.setState({
      // openMessageEdit: !open,
    });
  }

  render() {
    const { inheritModal, match } = this.props;
    const { selectedItemType, nameCategory } = this.state;
    const idEdit = match !== undefined ? match.params.id : false;

    return (
      <div>
        {!inheritModal && (
          <Breadcrumb crumb="Editar Categoria" description="Crie e edite novas categorias" />
        )}

        <Card className={!inheritModal ? 'center-box' : ''}>
          <div className="mg-left-20 box-categorys-models">
            <div className="bx--row mg-top-20 ">
              <div className="bx--col-xs-11 bx--col-md-6 v-sm-margin">
                <label htmlFor="tipo">Tipo</label>
                <br />
                <DropdownV2
                  label="Tipo"
                  id="tipo"
                  items={[
                    { id: 0, label: 'Selecione' },
                    { id: 1, label: 'Mensagem' },
                    { id: 2, label: 'SAC' },
                  ]}
                  selectedItem={selectedItemType}
                  onChange={e => this.onChange(e, 'tipo')}
                />
              </div>
            </div>
            <div className="bx--row ">
              <div className="bx--col-xs-11 bx--col-md-6 v-sm-margin">
                <TextInput
                  className="some-class"
                  id="nameCategory"
                  labelText="Nome da Categoria"
                  value={nameCategory}
                  onChange={e => this.onChange(e, 'nome')}
                  placeholder="Digite"
                />
              </div>
              {!inheritModal && (
                <div className="bx--col-xs-12 bx--col-md-5 v-center-link ">
                  <a
                    href="/admin/modelos-categorias"
                    title="Ir para o gerênciamento de categorias"
                    className="bx--link mg-top-20"
                  >
                    {' Gerenciar Categorias '}
                  </a>
                </div>
              )}

              <div className="bx--col-xs-12  v-md-margin">
                <Button onClick={idEdit ? this.edit : this.save}>Salvar</Button>
                <a onClick={() => this.cancel()} className="bx--link mg-left-20 pointer">
                  Cancelar
                </a>
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Gestao/Segmentos/Edit/Edit.jsx